module.exports = __webpack_public_path__ + "img/dial-off.5401ecb1.svg";